import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

import { openAuthModal } from '../../modules/auth/actions'

const StyledCTAText = styled.span`
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  text-align: center;
  color: #ffffff;
  height: 17px;
  vertical-align: top;
`
const StyledCTARect = styled(Button)`
  width: 124px;
  height: 34px;
  margin-top: 6px;
  border-radius: 4px;
  background: #916bff !important;
`

class CTA extends React.Component {
  static propTypes = {
    authUser: PropTypes.object
  }

  openModal = () => {
    if (this.props.authUser) {
      this.props.history.push('/homes')
    } else {
      this.props.openAuthModal({
        onSuccess: () => this.props.history.push('/homes'),
        longSignUpTitle: 'Create an account to view listings',
        longSignInTitle: 'Sign in to view listings'
      })
    }
  }

  render () {
    const { transparent } = this.props

    return (
      <div>
        <StyledCTARect
          onClick={this.openModal}
          color='primary'
          style={{
            background: transparent
              ? 'transparent'
              : '',
            border: transparent
              ? '1px solid white'
              : 'none'
          }}>
          <StyledCTAText>
            {'View Listings'}
          </StyledCTAText>
        </StyledCTARect>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  authUser: state.auth.authUser
})

const mapDispatchToProps = {
  openAuthModal
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CTA))
